import {useState,useEffect} from "react"
import { getBearer } from "utils/userStorage";
import {generateCodeChallengeFromVerifier,generateCodeVerifier,parseJwt} from "../../utils/OauthUtils"

export default function Threeshapelogout(){



    

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const state = urlParams.get('state');
        var decoded = decodeURIComponent(state)
        window.location.href = decoded
        
    }, []);


    return <div>
        this is the threeshapelogout page
    </div>
}
